<div class="container px-0 hide-lt-md">
	<div *ngFor="let item of footerConfig;let index = index" [class]=item.class class="px-0">
		<h4 class="f-title">{{item.label}}</h4>
		<ul>
			<li *ngFor="let option of item.options;">
				<a *ngIf="option.redirect" href="{{option.route}}" class="f-options">{{option.value}}</a>
				<a *ngIf="!option.redirect" routerLink={{option.route}} class="f-options">{{option.value}}</a>
			</li>
		</ul>
	</div>
	<div class="col-xs-12 col-sm-1 col-md-1 px-0"></div>
	<div class="col-xs-12 col-sm-4 col-md-4 px-0 subscription-block">
		<form [formGroup]=form (autocomplete)="'false'" (submit)="onSubmit(form)">
			<h4 class="f-title">Signup to receive exclusive offers and news</h4>
			<app-input leftIcon="mail" [placeholder]="'Enter your email address'"
				(onChangeEvent)="form.controls.name.setValue($event)"
				(onFocusOutEvent)="markTouchedAndDirty($event, 'name', form)" [value]="form.value.name"></app-input>
			<p class="error"
				*ngIf="form.get('name')?.invalid && (form.get('name')?.dirty || form.get('name')?.touched)">
				Please enter valid Email
			</p>
			<button type="submit" mat-flat-button class="btn-subscribe-now">Subscribe Now</button>
		</form>
	</div>
</div>